import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

function NextArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, display: 'block' }}
            onClick={onClick}
        />
    )
}

function PrevArrow(props) {
    const { className, style, onClick } = props
    return (
        <div
            className={className}
            style={{ ...style, display: 'block' }}
            onClick={onClick}
        />
    )
}

function HomePageSlider({ children }) {
    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: <NextArrow className="hidden md:block" />,
        prevArrow: <PrevArrow className="hidden md:block" />,
        // responsive: [
        //     {
        //         breakpoint: 768, // Adjust this value based on your needs
        //         settings: {
        //             arrows: false,
        //         },
        //     },
        // ],
    }
    return <Slider {...settings}>{children}</Slider>
}

export default HomePageSlider
